import { useEffect, useState } from "react";

import type * as RechartsModule from "recharts";

// Lazy-load recharts without top-level await to prevent circular chunk
// dependency deadlocks in production builds.
let _cached: typeof RechartsModule | null = null;
let _promise: Promise<typeof RechartsModule | null> | null = null;

function loadRecharts(): Promise<typeof RechartsModule | null> {
  _promise ??= import("recharts")
    .then((m) => {
      _cached = m;
      return m;
    })
    .catch(() => null);
  return _promise;
}

// Start loading immediately (non-blocking)
void loadRecharts();

/** React hook — returns recharts module once loaded, or null while loading. */
export function useRecharts(): typeof RechartsModule | null {
  const [mod, setMod] = useState(_cached);
  useEffect(() => {
    if (!mod) {
      void loadRecharts().then((m) => {
        if (m) setMod(m);
      });
    }
  }, [mod]);
  return mod;
}

export const CHART_TOOLTIP_STYLE = {
  background: "var(--glass-bg)",
  border: "1px solid var(--glass-border)",
  borderRadius: 2,
  fontFamily: "var(--font-mono)",
  fontSize: 11,
} as const;

export const CHART_AXIS_TICK = {
  fontSize: 10,
  fontFamily: "var(--font-mono)",
  fill: "var(--color-text-muted)",
} as const;

export const CHART_GRID_STROKE = "var(--color-gold-dim)";
